import { Navigate } from 'react-router-dom'
import { useGenerateCompanyPath } from '../../libs/hooks'
import { HUB_PAGES_PARENT_PATH } from '../../libs/routerPaths'

export const PagesIndexPage = () => {
  const { generatePath } = useGenerateCompanyPath()
  return <Navigate to={generatePath(HUB_PAGES_PARENT_PATH, { parent: 'uncategorized', child: null })} replace={true} />
}
